import { render, staticRenderFns } from "./SpotsMaps.vue?vue&type=template&id=5b150853&scoped=true"
import script from "./SpotsMaps.vue?vue&type=script&lang=js"
export * from "./SpotsMaps.vue?vue&type=script&lang=js"
import style0 from "./SpotsMaps.vue?vue&type=style&index=0&id=5b150853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b150853",
  null
  
)

export default component.exports